import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class QTotals extends Component {
  render() {
    const { qSheet, liveData, isDraft, refreshing, onRefreshQuantities } = this.props;

    const unit               = qSheet?.unitOfMeasure ?? "";
    const eeQuantity         = qSheet?.bidItemEeQuantity ?? 0;
    const ccoQuantity        = qSheet?.ccoQuantity ?? 0;
    const totalAuthorizedQty = qSheet?.totalAuthorizedQuantity ?? 0;
    const previouslyPaid     = qSheet?.previouslyPaidQuantity ?? 0;

    const totalReportedToDate = qSheet?.totalEstimatedReportedToDate ?? 0;

    // Prefer live values from QBody local state; fall back to saved Redux data
    const drQuantitySum = liveData?.reportSum ?? (qSheet?.rows ?? []).reduce(
      (sum, r) => sum + (parseFloat(r.estimatedQuantity) || 0),
      0
    );
    const adjustmentSum = liveData?.adjustmentTotal ?? (qSheet?.adjustments ?? []).reduce(
      (sum, a) => sum + (parseFloat(a.adjustmentAmount) || 0),
      0
    );

    const payThisEstimate = drQuantitySum + adjustmentSum;
    const totalPaidToDate = previouslyPaid + payThisEstimate;

    const overrunThreshold = totalAuthorizedQty * 1.25;
    const showOverrunWarning = totalAuthorizedQty > 0 && totalPaidToDate > overrunThreshold;

    const fmt = (n) => parseFloat(n.toFixed(3)).toString();

    return (
      <React.Fragment>
        <div className="card m-2">
          <div className="card-body">
            <div className="row align-items-center mb-3">
              <div className="col-6"><h5 className="mb-0">Totals</h5></div>
              <div className="col-6">
                {isDraft && (
                  <button
                    className="btn btn-sm btn-outline-secondary w-100"
                    type="button"
                    disabled={refreshing}
                    onClick={onRefreshQuantities}
                  >
                    <FontAwesomeIcon icon="sync-alt" className="mr-1" spin={refreshing} />
                    {refreshing ? "Refreshing..." : "Refresh Quantities"}
                  </button>
                )}
              </div>
            </div>

            <div className="form-group row align-items-center mb-2">
              <label className="col-6 col-form-label col-form-label-sm">
                Bid Item Qty (EE):
              </label>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={`${fmt(eeQuantity)} ${unit}`}
                  disabled
                />
              </div>
            </div>

            <div className="form-group row align-items-center mb-2">
              <label className="col-6 col-form-label col-form-label-sm">
                CCO Qty:
              </label>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={`${fmt(ccoQuantity)} ${unit}`}
                  disabled
                />
              </div>
            </div>

            <div className="form-group row align-items-center mb-2">
              <label className="col-6 col-form-label col-form-label-sm">
                <b>Total Authorized Qty:</b>
              </label>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={`${fmt(totalAuthorizedQty)} ${unit}`}
                  disabled
                />
              </div>
            </div>

            <hr className="my-2" />

            <div className="form-group row align-items-center mb-2">
              <label className="col-6 col-form-label col-form-label-sm text-primary">
                <b>Pay This Estimate:</b>
              </label>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control form-control-sm font-weight-bold text-primary"
                  value={`${fmt(payThisEstimate)} ${unit}`}
                  disabled
                />
              </div>
            </div>
            <hr className="my-2" />
            <div className="form-group row align-items-center mb-2">
              <label className="col-6 col-form-label col-form-label-sm">
                Previously Paid:
              </label>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={`${fmt(previouslyPaid)} ${unit}`}
                  disabled
                />
              </div>
            </div>

            <div className="form-group row align-items-center mb-2">
              <label className="col-6 col-form-label col-form-label-sm">
                <b>Total to Date:</b>
              </label>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={`${fmt(totalPaidToDate)} ${unit}`}
                  disabled
                />
              </div>
            </div>
            
            {showOverrunWarning && (
              <div className="alert alert-warning py-1 px-2 mb-2 small">
                <strong>Overrun:</strong> Total to Date exceeds 125% of authorized quantity.
              </div>
            )}

            <hr className="my-2" />

            <div className="form-group row align-items-center mb-2">
              <label className="col-6 col-form-label col-form-label-sm">
                Total Est. Reported to Date:
              </label>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={`${fmt(totalReportedToDate)} ${unit}`}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default QTotals;
